import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/image/tu1.png';
import _imports_1 from '../assets/image/tu2.png';
import _imports_2 from '../assets/image/tu3.jpg';
import _imports_3 from '../assets/image/tu4.jpg';
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "item1"
};
const _hoisted_3 = {
  class: "item_title"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "item2"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "index",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_10 = {
  class: "item3"
};
const _hoisted_11 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_12 = {
  style: {
    "width": "280px",
    "flex-shrink": "0"
  }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  style: {
    "padding": "0px 0px 20px 20px",
    "flex": "1",
    "min-width": "0"
  }
};
const _hoisted_15 = {
  class: "content2"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "park-news-title"
};
const _hoisted_18 = {
  class: "park-news-date"
};
const _hoisted_19 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_20 = {
  class: "content1"
};
const _hoisted_21 = {
  style: {
    "height": "230px",
    "width": "325px"
  }
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 0,
  style: {
    "padding": "0px 0px 20px 20px",
    "flex": "1"
  }
};
const _hoisted_24 = {
  class: "content2"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 0,
  class: "circle"
};
const _hoisted_27 = {
  key: 0,
  style: {
    "padding-left": "24px"
  }
};
const _hoisted_28 = {
  class: "news-conetnt",
  style: {
    "padding-top": "5px"
  }
};
const _hoisted_29 = {
  class: "date"
};
const _hoisted_30 = {
  class: "news-conetnt1"
};
const _hoisted_31 = {
  class: "p_height"
};
const _hoisted_32 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_33 = {
  class: "content1"
};
const _hoisted_34 = {
  style: {
    "height": "230px",
    "width": "325px"
  }
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  key: 0,
  style: {
    "padding": "0px 0px 20px 20px",
    "flex": "1"
  }
};
const _hoisted_37 = {
  class: "content2"
};
const _hoisted_38 = ["onClick"];
const _hoisted_39 = {
  key: 0,
  class: "circle"
};
const _hoisted_40 = {
  key: 0,
  style: {
    "padding-left": "24px"
  }
};
const _hoisted_41 = {
  class: "news-conetnt",
  style: {
    "padding-top": "5px"
  }
};
const _hoisted_42 = {
  class: "date"
};
const _hoisted_43 = {
  class: "news-conetnt1"
};
const _hoisted_44 = {
  class: "p_height"
};
const _hoisted_45 = {
  class: "index",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_46 = {
  class: "item3"
};
const _hoisted_47 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_48 = {
  class: "content1"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = {
  class: ""
};
const _hoisted_51 = {
  class: "n_title"
};
const _hoisted_52 = {
  class: "news-conetnt"
};
const _hoisted_53 = {
  class: "date"
};
const _hoisted_54 = {
  class: "news-conetnt1"
};
const _hoisted_55 = {
  class: "p_height"
};
const _hoisted_56 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_57 = {
  class: "content1"
};
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  class: ""
};
const _hoisted_60 = {
  class: "n_title"
};
const _hoisted_61 = {
  class: "news-conetnt"
};
const _hoisted_62 = {
  class: "date"
};
const _hoisted_63 = {
  class: "news-conetnt1"
};
const _hoisted_64 = {
  class: "p_height"
};
const _hoisted_65 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_66 = {
  class: "content1"
};
const _hoisted_67 = ["src"];
const _hoisted_68 = {
  class: ""
};
const _hoisted_69 = {
  class: "n_title"
};
const _hoisted_70 = {
  class: "news-conetnt"
};
const _hoisted_71 = {
  class: "date"
};
const _hoisted_72 = {
  class: "news-conetnt1"
};
const _hoisted_73 = {
  class: "p_height"
};
const _hoisted_74 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_75 = {
  class: "content1",
  style: {
    "width": "710px"
  }
};
const _hoisted_76 = ["src"];
const _hoisted_77 = {
  class: ""
};
const _hoisted_78 = {
  class: "n_title"
};
const _hoisted_79 = {
  class: "news-conetnt"
};
const _hoisted_80 = {
  class: "date"
};
const _hoisted_81 = {
  class: "news-conetnt1"
};
const _hoisted_82 = {
  class: "p_height"
};
const _hoisted_83 = {
  class: "hydt"
};
const _hoisted_84 = {
  class: "lmdt_content"
};
const _hoisted_85 = ["onClick"];
const _hoisted_86 = {
  class: "product",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_87 = {
  class: "item4"
};
const _hoisted_88 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_89 = {
  class: "content2",
  style: {
    "width": "100%",
    "margin": "0 auto"
  }
};
const _hoisted_90 = {
  style: {
    "display": "grid",
    "grid-template-columns": "repeat(\r\n\t\t\t\t\t\t\t\t\t\t\t\t4,\r\n\t\t\t\t\t\t\t\t\t\t\t\t1fr\r\n\t\t\t\t\t\t\t\t\t\t\t)",
    "margin-top": "30px"
  }
};
const _hoisted_91 = ["onClick"];
const _hoisted_92 = ["src"];
const _hoisted_93 = {
  class: "p_font"
};
const _hoisted_94 = {
  style: {
    "display": "grid",
    "grid-template-columns": "repeat(\r\n\t\t\t\t\t\t\t\t\t\t\t\t4,\r\n\t\t\t\t\t\t\t\t\t\t\t\t1fr\r\n\t\t\t\t\t\t\t\t\t\t\t)"
  }
};
const _hoisted_95 = ["onClick"];
const _hoisted_96 = ["src"];
const _hoisted_97 = {
  class: "p_font"
};
const _hoisted_98 = {
  class: "product",
  style: {
    "margin-top": "10px"
  }
};
const _hoisted_99 = {
  class: "item4",
  style: {
    "height": "700px"
  }
};
const _hoisted_100 = ["poster"];
const _hoisted_101 = ["src"];
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import Footer from "@/components/Footer.vue";
import { getBannerList, getMediaList, getHomeNews, getHomeProducts } from "@/api/home";
import { getArticlesByCategory } from "@/api/news";
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const activeName = ref("one");
    const activeName1 = ref("1");
    const activeName2 = ref("first");
    const activeName3 = ref("11");
    const activeName4 = ref("12");
    // 数据状态
    const bannerList = ref([]);
    const mediaList = ref([]);
    const newsList = ref([]);
    const productList = ref([]);
    // 各分类新闻数据
    const noticeList = ref([]); // 通知公告
    const techNewsList = ref([]); // 科技新闻
    const activityList = ref([]); // 院内活动
    const industryList = ref([]); // 行业动态
    // 园区动态区域数据
    const parkNewsList = ref([]); // 园区动态 - categoryId: 13
    const selectedParkNewsIndex = ref(0); // 当前选中的园区动态新闻索引
    const financeList = ref([]); // 投融资服务 - categoryId: 14
    const selectedFinanceIndex = ref(0); // 当前选中的投融资服务新闻索引
    const techTransferList = ref([]); // 技术转移 - categoryId: 15
    const selectedTechTransferIndex = ref(0); // 当前选中的技术转移新闻索引
    // 科研动态区域数据
    const researchList = ref([]); // 科研动态 - categoryId: 16
    const pilotList = ref([]); // 中试中心 - categoryId: 17
    const inspectionList = ref([]); // 检验检测 - categoryId: 18
    const innovationList = ref([]); // 创新成果 - categoryId: 19
    const handleClick = (tab, event) => {
      // console.log(tab, event);
    };
    const router = useRouter();
    const handleSelect = item => {
      // console.log(item);
      router.push({
        path: item
      });
    };
    // 跳转到新闻列表页
    const goToNewsList = categoryId => {
      router.push({
        path: "/newslist",
        query: {
          categoryId: categoryId
        }
      });
    };
    // 跳转到新闻详情页
    const goToNewsDetail = id => {
      router.push(`/xwxq/${id}`);
    };
    // 跳转到产品详情页面
    const goToProduct = productId => {
      router.push(`/product/${productId}`);
    };
    // 获取轮播图数据
    const fetchBannerList = async () => {
      try {
        const res = await getBannerList();
        // console.log("轮播图数据:", res);
        bannerList.value = res.data || [];
      } catch (error) {
        console.error("获取轮播图失败:", error);
      }
    };
    // 获取媒体公开数据
    const fetchMediaList = async () => {
      try {
        const res = await getMediaList();
        // console.log("媒体公开数据:", res);
        mediaList.value = res.data || [];
      } catch (error) {
        console.error("获取媒体公开失败:", error);
      }
    };
    // 获取首页新闻数据
    const fetchHomeNews = async () => {
      try {
        const res = await getHomeNews();
        // console.log("首页新闻数据:", res);
        newsList.value = res.data || [];
      } catch (error) {
        console.error("获取首页新闻失败:", error);
      }
    };
    // 获取产品展示数据
    const fetchHomeProducts = async () => {
      try {
        const res = await getHomeProducts();
        // console.log("产品展示数据:", res);
        productList.value = res.data || [];
      } catch (error) {
        console.error("获取产品展示失败:", error);
      }
    };
    // 获取分类新闻数据
    const fetchCategoryNews = async (categoryId, pageSize = 3) => {
      try {
        const res = await getArticlesByCategory({
          categoryId: categoryId,
          pageNum: 1,
          pageSize: pageSize
        });
        return res.data?.list || [];
      } catch (error) {
        console.error(`获取分类${categoryId}新闻失败:`, error);
        return [];
      }
    };
    // 获取所有分类新闻
    const fetchAllCategoryNews = async () => {
      try {
        // 并行获取所有分类的新闻
        const [notice, techNews, activity, parkNews, finance, techTransfer, research, pilot, inspection, innovation, industry] = await Promise.all([fetchCategoryNews(10, 3),
        // 通知公告
        fetchCategoryNews(11, 3),
        // 科技新闻
        fetchCategoryNews(12, 3),
        // 院内活动
        fetchCategoryNews(13, 6),
        // 园区动态
        fetchCategoryNews(14, 4),
        // 投融资服务
        fetchCategoryNews(15, 4),
        // 技术转移
        fetchCategoryNews(16, 1),
        // 科研动态
        fetchCategoryNews(17, 1),
        // 中试中心
        fetchCategoryNews(18, 1),
        // 检验检测
        fetchCategoryNews(19, 1),
        // 创新成果
        fetchCategoryNews(20, 3) // 行业动态
        ]);
        noticeList.value = notice;
        techNewsList.value = techNews;
        activityList.value = activity;
        parkNewsList.value = parkNews;
        financeList.value = finance;
        techTransferList.value = techTransfer;
        researchList.value = research;
        pilotList.value = pilot;
        inspectionList.value = inspection;
        innovationList.value = innovation;
        industryList.value = industry;
      } catch (error) {
        console.error("获取分类新闻失败:", error);
      }
    };
    // 页面加载时获取所有数据
    onMounted(() => {
      fetchBannerList();
      fetchMediaList();
      fetchHomeNews();
      fetchHomeProducts();
      fetchAllCategoryNews(); // 获取所有分类新闻
    });
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [bannerList.value.length ? (_openBlock(), _createBlock(_component_el_carousel, {
        key: 0,
        "indicator-position": ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, item => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: item.id
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1), _createElementVNode("img", {
              src: item.url,
              alt: "banner",
              height: "321px"
            }, null, 8, _hoisted_4)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick,
        type: "card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "通知公告",
          name: "one"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "news-header",
            onClick: _cache[0] || (_cache[0] = $event => goToNewsList(10))
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("div", {
            class: "font_color"
          }, "通知公告", -1), _createElementVNode("div", {
            class: "line"
          }, null, -1), _createElementVNode("div", {
            class: "font_color"
          }, "更多+", -1)]))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "news-conetnt",
              key: item.id,
              onClick: $event => goToNewsDetail(item.id)
            }, [_cache[15] || (_cache[15] = _createElementVNode("span", {
              class: "circle"
            }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.title), 1)], 8, _hoisted_6);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "科技新闻",
          name: "two"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "news-header",
            onClick: _cache[1] || (_cache[1] = $event => goToNewsList(11))
          }, [...(_cache[16] || (_cache[16] = [_createElementVNode("div", {
            class: "font_color"
          }, "科技新闻", -1), _createElementVNode("div", {
            class: "line"
          }, null, -1), _createElementVNode("div", {
            class: "font_color"
          }, "更多+", -1)]))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(techNewsList.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "news-conetnt",
              key: item.id,
              onClick: $event => goToNewsDetail(item.id)
            }, [_cache[17] || (_cache[17] = _createElementVNode("span", {
              class: "circle"
            }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.title), 1)], 8, _hoisted_7);
          }), 128))]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "院内活动",
          name: "three"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "news-header",
            onClick: _cache[2] || (_cache[2] = $event => goToNewsList(12))
          }, [...(_cache[18] || (_cache[18] = [_createElementVNode("div", {
            class: "font_color"
          }, "院内活动", -1), _createElementVNode("div", {
            class: "line"
          }, null, -1), _createElementVNode("div", {
            class: "font_color"
          }, "更多+", -1)]))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityList.value, item => {
            return _openBlock(), _createElementBlock("div", {
              class: "news-conetnt",
              key: item.id,
              onClick: $event => goToNewsDetail(item.id)
            }, [_cache[19] || (_cache[19] = _createElementVNode("span", {
              class: "circle"
            }, null, -1)), _createElementVNode("span", null, _toDisplayString(item.title), 1)], 8, _hoisted_8);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_tabs, {
        modelValue: activeName2.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => activeName2.value = $event),
        class: "demo-tabs",
        type: "card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "园区动态",
          name: "first"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
            src: parkNewsList.value[0]?.coverImage || '../assets/image/640.png',
            alt: "alg",
            style: {
              "width": "280px",
              "height": "230px",
              "object-fit": "cover"
            }
          }, null, 8, _hoisted_13)]), parkNewsList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parkNewsList.value, item => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "park-news-item",
              onClick: $event => goToNewsDetail(item.id)
            }, [_createElementVNode("span", _hoisted_17, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_18, _toDisplayString(item.publishTime?.substring(0, 10)), 1)], 8, _hoisted_16);
          }), 128))])])) : _createCommentVNode("", true)])]),
          _: 1
        }), false ? (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: 0,
          label: "投融资服务",
          name: "second"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
            src: financeList.value[0]?.coverImage || '../assets/image/yqdt.png',
            alt: "alg",
            style: {
              "width": "325px",
              "height": "230px",
              "object-fit": "cover"
            }
          }, null, 8, _hoisted_22)])]), financeList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(financeList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              style: {
                "cursor": "pointer"
              }
            }, [_createElementVNode("div", {
              class: _normalizeClass(["news-conetnt", {
                'news-hover': index !== 0
              }]),
              onClick: $event => goToNewsDetail(item.id)
            }, [index !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_26)) : _createCommentVNode("", true), _createElementVNode("span", {
              class: _normalizeClass({
                'n_title': index === 0
              }),
              style: {
                "font-weight": "600"
              }
            }, _toDisplayString(item.title), 3)], 10, _hoisted_25), index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, _toDisplayString(item.publishTime?.substring(0, 10)), 1)]), _createElementVNode("div", _hoisted_30, [_createElementVNode("p", _hoisted_31, _toDisplayString(item.summary || item.seoDescription), 1)])])) : _createCommentVNode("", true)]);
          }), 128))])])) : _createCommentVNode("", true)])]),
          _: 1
        })) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_component_el_tab_pane, {
          key: 1,
          label: "技术转移",
          name: "third"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("img", {
            src: techTransferList.value[0]?.coverImage || '../assets/image/yqdt.png',
            alt: "alg",
            style: {
              "width": "325px",
              "height": "230px",
              "object-fit": "cover"
            }
          }, null, 8, _hoisted_35)])]), techTransferList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(techTransferList.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              style: {
                "cursor": "pointer"
              }
            }, [_createElementVNode("div", {
              class: _normalizeClass(["news-conetnt", {
                'news-hover': index !== 0
              }]),
              onClick: $event => goToNewsDetail(item.id)
            }, [index !== 0 ? (_openBlock(), _createElementBlock("span", _hoisted_39)) : _createCommentVNode("", true), _createElementVNode("span", {
              class: _normalizeClass({
                'n_title': index === 0
              }),
              style: {
                "font-weight": "600"
              }
            }, _toDisplayString(item.title), 3)], 10, _hoisted_38), index === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("span", _hoisted_42, _toDisplayString(item.publishTime?.substring(0, 10)), 1)]), _createElementVNode("div", _hoisted_43, [_createElementVNode("p", _hoisted_44, _toDisplayString(item.summary || item.seoDescription), 1)])])) : _createCommentVNode("", true)]);
          }), 128))])])) : _createCommentVNode("", true)])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", {
        class: "lmdt",
        onClick: _cache[5] || (_cache[5] = $event => handleSelect('xwzx'))
      }, [_cache[24] || (_cache[24] = _createStaticVNode("<div class=\"lmdt_content\" data-v-43d56632><div class=\"lmdt_title\" data-v-43d56632></div><div class=\"lmdt_font\" data-v-43d56632>联盟动态</div><div class=\"more\" data-v-43d56632></div></div><div class=\"line_border\" data-v-43d56632></div>", 2)), _createVNode(_component_el_row, {
        style: {
          "margin": "10px 0px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createElementVNode("img", {
            src: _imports_0,
            alt: "alg",
            class: "t_image"
          }, null, -1)]))]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 2
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createElementVNode("img", {
            src: _imports_1,
            alt: "alg",
            class: "t_image"
          }, null, -1)]))]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createElementVNode("img", {
            src: _imports_2,
            alt: "alg",
            class: "t_image"
          }, null, -1)]))]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 2
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createElementVNode("img", {
            src: _imports_3,
            alt: "alg",
            class: "t_image"
          }, null, -1)]))]),
          _: 1
        })]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createVNode(_component_el_tabs, {
        modelValue: activeName1.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => activeName1.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick,
        type: "card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "科研动态",
          name: "1"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createVNode(_component_el_carousel, {
            height: "230px",
            style: {
              "width": "325px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(researchList.value.slice(0, 1), item => {
              return _openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: item.coverImage || '../assets/image/641.png',
                  alt: "alg"
                }, null, 8, _hoisted_49)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]), researchList.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {
              "padding": "0px 0px 20px 20px"
            },
            onClick: _cache[6] || (_cache[6] = $event => goToNewsDetail(researchList.value[0].id))
          }, [_createElementVNode("div", _hoisted_50, [_createElementVNode("span", _hoisted_51, _toDisplayString(researchList.value[0].title), 1)]), _createElementVNode("div", _hoisted_52, [_createElementVNode("span", _hoisted_53, _toDisplayString(researchList.value[0].publishTime?.substring(0, 10)), 1)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("p", _hoisted_55, _toDisplayString(researchList.value[0].summary || researchList.value[0].seoDescription), 1)])])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "中试中心",
          name: "2"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createVNode(_component_el_carousel, {
            height: "230px",
            style: {
              "width": "325px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pilotList.value.slice(0, 1), item => {
              return _openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: item.coverImage || '../assets/image/kydt.png',
                  alt: "alg"
                }, null, 8, _hoisted_58)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]), pilotList.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {
              "padding": "0px 0px 20px 20px"
            },
            onClick: _cache[7] || (_cache[7] = $event => goToNewsDetail(pilotList.value[0].id))
          }, [_createElementVNode("div", _hoisted_59, [_createElementVNode("span", _hoisted_60, _toDisplayString(pilotList.value[0].title), 1)]), _createElementVNode("div", _hoisted_61, [_createElementVNode("span", _hoisted_62, _toDisplayString(pilotList.value[0].publishTime?.substring(0, 10)), 1)]), _createElementVNode("div", _hoisted_63, [_createElementVNode("p", _hoisted_64, _toDisplayString(pilotList.value[0].summary || pilotList.value[0].seoDescription), 1)])])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "检验检测",
          name: "3"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createVNode(_component_el_carousel, {
            height: "230px",
            style: {
              "width": "325px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inspectionList.value.slice(0, 1), item => {
              return _openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: item.coverImage || '../assets/image/kydt.png',
                  alt: "alg"
                }, null, 8, _hoisted_67)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]), inspectionList.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {
              "padding": "0px 0px 20px 20px"
            },
            onClick: _cache[8] || (_cache[8] = $event => goToNewsDetail(inspectionList.value[0].id))
          }, [_createElementVNode("div", _hoisted_68, [_createElementVNode("span", _hoisted_69, _toDisplayString(inspectionList.value[0].title), 1)]), _createElementVNode("div", _hoisted_70, [_createElementVNode("span", _hoisted_71, _toDisplayString(inspectionList.value[0].publishTime?.substring(0, 10)), 1)]), _createElementVNode("div", _hoisted_72, [_createElementVNode("p", _hoisted_73, _toDisplayString(inspectionList.value[0].summary || inspectionList.value[0].seoDescription), 1)])])) : _createCommentVNode("", true)])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "创新成果",
          name: "4"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_createVNode(_component_el_carousel, {
            height: "230px",
            style: {
              "width": "325px"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(innovationList.value.slice(0, 1), item => {
              return _openBlock(), _createBlock(_component_el_carousel_item, {
                key: item.id
              }, {
                default: _withCtx(() => [_createElementVNode("img", {
                  src: item.coverImage || '../assets/image/kydt.png',
                  alt: "alg"
                }, null, 8, _hoisted_76)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]), innovationList.value.length > 0 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: {
              "padding": "0px 0px 20px 20px"
            },
            onClick: _cache[9] || (_cache[9] = $event => goToNewsDetail(innovationList.value[0].id))
          }, [_createElementVNode("div", _hoisted_77, [_createElementVNode("span", _hoisted_78, _toDisplayString(innovationList.value[0].title), 1)]), _createElementVNode("div", _hoisted_79, [_createElementVNode("span", _hoisted_80, _toDisplayString(innovationList.value[0].publishTime?.substring(0, 10)), 1)]), _createElementVNode("div", _hoisted_81, [_createElementVNode("p", _hoisted_82, _toDisplayString(innovationList.value[0].summary || innovationList.value[0].seoDescription), 1)])])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_cache[25] || (_cache[25] = _createElementVNode("div", {
        class: "lmdt_title"
      }, null, -1)), _cache[26] || (_cache[26] = _createElementVNode("div", {
        class: "lmdt_font"
      }, "行业动态", -1)), _createElementVNode("div", {
        class: "more",
        onClick: _cache[11] || (_cache[11] = $event => goToNewsList(20))
      }, "更多+")]), _cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "line_border"
      }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "news_title",
          key: item.id,
          onClick: $event => goToNewsDetail(item.id)
        }, _toDisplayString(item.title), 9, _hoisted_85);
      }), 128))])]), _createElementVNode("div", _hoisted_86, [_createElementVNode("div", _hoisted_87, [_createVNode(_component_el_tabs, {
        modelValue: activeName3.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => activeName3.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick,
        type: "card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "产品展示",
          name: "11"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createVNode(_component_el_carousel, {
            height: "520px",
            style: {
              "text-align": "center"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(productList.value.length / 8), pageIndex => {
              return _openBlock(), _createBlock(_component_el_carousel_item, {
                key: pageIndex
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_90, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value.slice((pageIndex - 1) * 8, (pageIndex - 1) * 8 + 4), product => {
                  return _openBlock(), _createElementBlock("div", {
                    class: "c_item",
                    key: product.id,
                    onClick: $event => goToProduct(product.id)
                  }, [_createElementVNode("img", {
                    src: product.productImage,
                    alt: "product",
                    class: "c_image"
                  }, null, 8, _hoisted_92), _createElementVNode("div", _hoisted_93, _toDisplayString(product.name), 1)], 8, _hoisted_91);
                }), 128))]), _createElementVNode("div", _hoisted_94, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value.slice((pageIndex - 1) * 8 + 4, pageIndex * 8), product => {
                  return _openBlock(), _createElementBlock("div", {
                    class: "c_item",
                    key: product.id,
                    onClick: $event => goToProduct(product.id)
                  }, [_createElementVNode("img", {
                    src: product.productImage,
                    alt: "product",
                    class: "c_image"
                  }, null, 8, _hoisted_96), _createElementVNode("div", _hoisted_97, _toDisplayString(product.name), 1)], 8, _hoisted_95);
                }), 128))])]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_98, [_createElementVNode("div", _hoisted_99, [_createVNode(_component_el_tabs, {
        modelValue: activeName4.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => activeName4.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick,
        type: "card"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "媒体公开",
          name: "12"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_carousel, {
            "indicator-position": "",
            height: "600px",
            autoplay: false
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mediaList.value, media => {
              return _openBlock(), _createBlock(_component_el_carousel_item, {
                key: media.id
              }, {
                default: _withCtx(() => [_createElementVNode("video", {
                  controls: "",
                  width: "100%",
                  height: "600px",
                  poster: media.coverImage,
                  playsinline: "",
                  "webkit-playsinline": "",
                  "x5-video-player-type": "h5",
                  "x5-video-player-fullscreen": "true",
                  "x5-video-orientation": "portraint"
                }, [_createElementVNode("source", {
                  src: media.attachment,
                  type: "video/mp4"
                }, null, 8, _hoisted_101), _cache[28] || (_cache[28] = _createTextVNode(" 你的浏览器不支持视频播放。 ", -1))], 8, _hoisted_100)]),
                _: 2
              }, 1024);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])]), _createVNode(Footer)], 64);
    };
  }
});